(() => {
  const header = document.getElementById('my_sticky_header');

  if (header) {
    const root = document.documentElement;
    let rafId = null;

    const observer = new ResizeObserver((entries) => {
      for (const entry of entries) {
        // Use borderBoxSize for full rendered height (including padding/borders)
        const height = entry.borderBoxSize?.[0]?.blockSize ?? entry.contentRect.height;
        
        // Batch the DOM write inside requestAnimationFrame to avoid layout thrashing
        if (rafId) cancelAnimationFrame(rafId);
        rafId = requestAnimationFrame(() => {
          root.style.setProperty('--header-group-height', `${height}px`);
        });
      }
    });

    observer.observe(header);
  }
})();